import { useParams } from 'react-router-dom'
import httpClient from '../shared/axios'
import { useEffect, useState } from 'react'
import { useLanguage } from '../context/languageContext';

export default function ProfessorDetail() {
    const { id } = useParams()
    const { language } = useLanguage();
    const [data, setData] = useState({})

    useEffect(() => {
        const getSingleDailyActivity = async () => {
            const { data } = await httpClient.get(`/professors/${id}/?lang=${language === 'oz' ? 'uz-cyrl' : language}`);
            setData(data)
        };

        getSingleDailyActivity();
    }, [id, language]);

    return (

        <div className="ProfessorDetail py-5">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5">
                        <img className='w-100' src={data?.image} alt={data?.name} />
                    </div>
                    <div className="col-lg-6 offset-lg-1">
                        <h3 className='my-3'>{data?.first_name} {data?.last_name} {data?.last_name}</h3>
                        <h4 className='mb-2'>{data?.position}</h4>
                        <p className='mb-2'>{data?.specialty}</p>
                        <a href={`tel:${data?.phone}`} className='mb-2'>{data?.phone}</a> <br />
                        <a href={`mailto:${data?.email}`} className='mb-2'>{data?.email}</a>
                        {data?.orcid ? <p className='mb-2'>ORCID: {data?.orcid}</p> : ''}
                    </div>
                </div>
            </div>
        </div>
    )
}
